"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proxiedUrl = exports.processedUrl = void 0;

const imgix = __importStar(require("./imgix"));

const inhouseService = __importStar(require("./inhouse_service"));

const options_parser_1 = require("./options_parser");

const url_builder_1 = require("./url_builder");

const url_parser_1 = require("./url_parser");

const processedUrl = (url, options = {}) => {
  if (!url) {
    console.info(`[vivaldi-client] url is blank`);
  } // if url is blank or url is relative, just return it. There isn't much we can do.


  if (!url || url.startsWith('/')) return url; // Setting options

  const transformOptions = options_parser_1.getTransformOptions(options); // We have to use unsplash's own image api per policy.

  if (imgix.canServe(url)) {
    return imgix.processedUrl(url, transformOptions);
  } else {
    const cleanUrl = url_parser_1.cleanUrlForInhouse(url);
    return inhouseService.processedUrl(cleanUrl, transformOptions);
  }
};

exports.processedUrl = processedUrl;
const proxiedUrl = url_builder_1.buildProxyUrl;
exports.proxiedUrl = proxiedUrl;